<div class="mat-typography dialog">
  <div class="section payable">
    <div class="invoices">
      <div class="mat-h3">Invoices to pay</div>
      @for (invoice of invoices$ | async; track invoice) {
        <div class="invoice-line">
          <div class="invoice-reference">
            <mat-checkbox
              (click)="toggleInvoice(invoice.id)"
              [checked]="isInvoiceSelected(invoice.id) | async">
              {{ invoice.reference }}
            </mat-checkbox>
          </div>
          <div class="invoice-date">
            {{ invoice.date | date }}
          </div>
          <div class="invoice-outstanding">
            {{ invoice.outstanding | currency:invoice.currency }}
          </div>
        </div>
      }
      <mat-divider></mat-divider>
    </div>
    <div class="credit-notes">
      <div class="mat-h3">Credit notes to apply</div>
      @for (invoice of creditNotes$ | async; track invoice) {
        <div class="invoice-line">
          <div class="invoice-reference">
            <mat-checkbox
              (click)="toggleInvoice(invoice.id)"
              [checked]="isInvoiceSelected(invoice.id) | async">
              {{ invoice.reference }}
            </mat-checkbox>
          </div>
          <div class="invoice-date">
            {{ invoice.date | date }}
          </div>
          <div class="invoice-outstanding">
            {{ invoice.outstanding | currency:invoice.currency }}
          </div>
        </div>
      }
      <mat-divider></mat-divider>
    </div>
    <div class="total">
      <div class="mat-h4">Amount due</div>
      <div class="amount">{{ amount$ | async | currency:(currency$ | async) }}</div>
    </div>
  </div>
  <div class="section payment">
    <div class="mat-h3">Method of Payment</div>
    <mat-radio-group>
      @for (card of creditCards$ | async; track card) {
        <div class="credit-card">
          <div class="card-select">
            <mat-radio-button [value]="card.id">
              <app-credit-card-display [creditCard]="card"></app-credit-card-display>
            </mat-radio-button>
          </div>
        </div>
      }
    </mat-radio-group>
  </div>
</div>
